import React, { PureComponent } from "react";
import { Row, Col, Card, CardBody, CardHeader } from "reactstrap";
import moment from "moment";

import transactions from "@/api/transactions";
import accounts from "@/api/accounts";
import reports from "@/api/reports";

import TransactionsTable from "../Components/TransactionsTable";
import TableContainer from "../Components/TableContainer";
import LoadingOverlay from "../Components/LoadingOverlay";
import CurrencyCard from "../Components/CurrencyCard";
import { handleError } from "@/util/errorHandler";

class Dashboard extends PureComponent {
  state = {
    isSummaryLoading: true,
    totalAccount: 0,
    totalAmountKhr: 0,
    totalAmountUsd: 0,
    accountDomain: "-",
  };

  componentDidMount() {
    this.loadAccountsSummary();
  }

  loadAccountsSummary = async () => {
    try {
      this.setState({ isSummaryLoading: true });

      const data = await accounts.getAllAccountsSummary();

      this.setState({
        totalAccount: data.totalAccount,
        totalAmountKhr: data.totalAmounts["khr#nbc"],
        totalAmountUsd: data.totalAmounts["usd#nbc"],
        accountDomain: data.accountDomain,
      });
    } catch (err) {
      handleError(err);
    } finally {
      this.setState({ isSummaryLoading: false });
    }
  };

  render() {
    return (
      <div className="animated fadeIn">
        <Row style={{ marginBottom: 20 }}>
          <LoadingOverlay loading={this.state.isSummaryLoading} />
          <Col xl="6" lg="12" sm="12" md="12">
            <h4>Total balance</h4>
            <Row>
              <Col xl="6" lg="12" sm="12" md="12">
                <Card>
                  <CardBody style={{ padding: 10 }}>
                    <CurrencyCard
                      title="Riel account"
                      currency="riel"
                      balance={this.state.totalAmountKhr}
                      data-cy="riel"
                    />
                  </CardBody>
                </Card>
              </Col>
              <Col xl="6" lg="12" sm="12" md="12">
                <Card>
                  <CardBody style={{ padding: 10 }}>
                    <CurrencyCard
                      title="Dollar account"
                      currency="usd"
                      balance={this.state.totalAmountUsd}
                      data-cy="dollar"
                    />
                  </CardBody>
                </Card>
              </Col>
            </Row>
            <h3 data-cy="total">
              Total number of accounts: {this.state.totalAccount}
            </h3>
          </Col>
        </Row>
        <Row>
          <Col xl="6" lg="12" sm="12" md="12">
            <Card data-cy="incoming">
              <CardHeader>Incoming Transactions</CardHeader>
              <CardBody>
                <TableContainer
                  loadData={transactions.getTodayIncomingTransactions}
                  requestReport={reports.requestIncomingTransactions}
                  reportWithoutDateRange
                  reportWithInitialDates={{
                    dateFrom: moment(),
                    dateTo: moment(),
                  }}>
                  <TransactionsTable type="incoming" />
                </TableContainer>
              </CardBody>
            </Card>
          </Col>
          <Col xl="6" lg="12" sm="12" md="12">
            <Card data-cy="outgoing">
              <CardHeader>Outgoing Transactions</CardHeader>
              <CardBody>
                <TableContainer
                  loadData={transactions.getTodayOutgoingTransactions}
                  requestReport={reports.requestOutgoingTransactions}
                  reportWithoutDateRange
                  reportWithInitialDates={{
                    dateFrom: moment(),
                    dateTo: moment(),
                  }}>
                  <TransactionsTable type="outgoing" />
                </TableContainer>
              </CardBody>
            </Card>
          </Col>
        </Row>
      </div>
    );
  }
}

export default Dashboard;
